import { render, staticRenderFns } from "./FinalSettings.vue?vue&type=template&id=f243f1bc&scoped=true&lang=html&"
import script from "./FinalSettings.vue?vue&type=script&lang=js&"
export * from "./FinalSettings.vue?vue&type=script&lang=js&"
import style0 from "./FinalSettings.vue?vue&type=style&index=0&id=f243f1bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f243f1bc",
  null
  
)

export default component.exports